module.exports = __webpack_public_path__ + "img/stripe.875a4de7.svg";